// src/components/DocumentsColumn.jsx
import React from "react";

const ShortDocCol = () => {
  const documents = [
    "मा. बाळासाहेब ठाकरे स्मृती मातोश्री ग्रामपंचायत बांधणी योजनेतर्गत सातारा जिल्ह्यातील 4 ग्रामपंचायतींच्या इमारत बांधकामास मंजुरी प्रदान करण्याबाबत...",
    "महाराष्ट्र विकास सेवा, गट-ब मधील सहाय्यक गट विकास अधिकारी (एस-16) संदर्भातील अधिकाऱ्यांना गट विकास अधिकारी, गट-अ (एस-20) संदर्भात तदर्थ पदोन्नती देण्याबाबत. (निवडसूची वर्ष 2024-25)",
    "कोकण ग्रामीण पर्यटन विकास कार्यक्रमांतर्गत कडेर्दा ता.दापोली जि. रत्नागिरी येथील प्रशासनिक मान्यता दिलेल्या कामांना निधी वितरीत करण्याबाबत.",
    "सन 2025-26 राज्य शासनाकडून समुदाय संसाधन व्यक्ती (Community Resource Person-CRP) / प्रेरीका (ICRP) / सखी यांना देण्यात येणारे वाढीव मानधन निधी वितरीत करण्याबाबत.",
    "मा. बाळासाहेब ठाकरे स्मृती मातोश्री ग्रामपंचायत बांधणी योजनेतर्गत सातारा जिल्ह्यातील 4 ग्रामपंचायतींच्या इमारत बांधकामास मंजुरी प्रदान करण्याबाबत..."
  ];

  return (
    <div className="bg-custom-gray p-4 border rounded shadow-sm">
      <h2 className="font-bold text-lg border-b pb-2 mb-2">दस्तऐवज</h2>
      <ul className="list-disc pl-5 space-y-2 text-gray-700">
        {documents.map((doc, idx) => (
          <li key={idx}>{doc}</li>
        ))}
      </ul>
    </div>
  );
};

export default ShortDocCol;
